import cpt_button_option from './cpt-button-option'
let op = JSON.parse(JSON.stringify(cpt_button_option))

op.cptDataForm.dataText = '{"value":"保存&更新"}'

export default op